export const DESCRIPTION =
  'By default, your audience is everyone. Refine your audience by adding segments and narrow in on shoppers that share similar characteristics or interests. '
